import React, { useCallback, useEffect } from 'react';
import { Button, Grid } from '@mui/material';
import { useStakingContext } from '../../contexts/staking.context';
import { useUserContext } from '../../../../context/user.context';
import { useAccount } from 'wagmi';

export const StakeInput = ({ vault }) => {
  const [stakeValue, setStakeValue] = React.useState('0');
  const { isOzkBalanceGraterOrEqThan, deposit } = useStakingContext();
  const { isLoggedIn } = useUserContext();
  const { address } = useAccount();

  const onChangeAmount = async (value: string) => {
    if (value === '') {
      setStakeValue('0');
      return;
    }
    if (isOzkBalanceGraterOrEqThan(Number(value)) && value.length < 10) {
      if (value.length < 10) {
        setStakeValue(value);
      }
    }
  };

  const onClickStake = useCallback(async () => {
    if (stakeValue && Number(stakeValue) > 0) {
      await deposit(stakeValue, vault);
    }
  }, [stakeValue, deposit, vault]);

  useEffect(() => {
    if (!isLoggedIn || !address) {
      setStakeValue('0');
    }
  }, [isLoggedIn, address]);

  return (
    <Grid
      item
      lg={3}
      md={3}
      sm={12}
      xs={12}
      sx={{
        padding: '8px 16px',
        borderRadius: '12px',
        border: '1px solid #5F4C3E',
      }}
      display="flex"
      justifyContent={{ xs: 'space-between', md: 'flex-start' }}
      alignItems="center"
    >
      <Grid display="flex" flexDirection="column">
        <p className="text-white font-poppins text-xs font-normal leading-5">
          OZK Stake
        </p>
        <input
          type="number"
          className="p-2"
          style={{
            background: 'transparent',
            color: '#ffffff',
            width: '100%',
            border: '0',
            borderTopLeftRadius: '12px',
            borderBottomLeftRadius: '12px',
          }}
          placeholder={'Enter Amount'}
          value={stakeValue}
          onChange={(e) => onChangeAmount(e.target.value)}
          onWheel={(e) => e.currentTarget.blur()}
        />
      </Grid>
      <Grid>
        <Button
          sx={{
            height: '39px',
            width: 'auto',
            background:
              'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
            border: '1px solid  #FC9D4B',
            borderColor: '#FC9D4B',
            borderRadius: '25px',
            color: '#FFFFFF',
            fontWeight: 'semibold',
            fontFamily: 'PoppinsRegular',
            fontSize: '18px',
            padding: '7px 15px',
            '&:hover': {
              background:
                'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
              boxShadow: '0px 0px 13px 1px #FC9D4B',
            },
            textTransform: 'none',
          }}
          onClick={onClickStake}
        >
          Stake
        </Button>
      </Grid>
    </Grid>
  );
};
